import { Modal } from "ant-design-vue";
import lodash from "lodash";
import moment from "moment";
import { createFieldRadioGroup, createFieldSelect, createFieldTextArea } from "../../../../components/input/template-builder/template-builder.logic";
import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import router from "../../../../router";
import store from "../../../../store";
import { conditionFormChecker, copyForm, putField } from "../../../../utils/form";
import { callRequestStatus } from "../../storage-location/request/request.section";
import { defineAsyncComponent } from "vue";
import { callUser } from "../../storage-location/request/requestor/requestor.section";

const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));

export const callRequestType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", {
        group: "REQUEST_TYPE",
        value: searchQuery,
        where: [{ name: "key", type: "String", operator: "in", value: ["1", "2", "4"] }]
    });

export const callObjectiveType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REQUEST_OBJECTIVE", value: searchQuery });

export const callToWhomAttachment = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "TO_WHOM_ATTACHMENT", value: searchQuery });

export const callToWhom = ({ searchQuery, userInfo, isOfficerCreate }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") }
    ];
    if (!isOfficerCreate) {
        where.push(
            { openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 1
            { name: "refUserCompany.id", type: "UUID", operator: "=", value: userInfo?.refParent?.id || userInfo?.id },

            { logic: "OR", openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 2
            { name: "refUserCompany.userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
            { name: "refUserCompany.userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
            { name: "refUserCompany.userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
            { name: "refUserCompany.userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "2" },
            { name: "refUserCompany.userAuthorizes.refAuthorize.id", type: "UUID", operator: "=", value: userInfo?.refParent?.id || userInfo?.id },

            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "1" },
            {
                name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.refAuthorize.id",
                type: "Getpath",
                operator: "=",
                value: "refUserCompany.id"
            },
            { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 2
            { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" } // 1
        );
    }
    if (searchQuery) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: searchQuery });
    }

    return store
        .dispatch("resource/v1/transaction/toWhom/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "approveCode", "refUserCompany.id", "refUserCompany.fullNameTh"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};
export const callToWhomFull = ({ id }) => {
    return store
        .dispatch("resource/v1/transaction/toWhom/search", {
            criteria: {
                isDistinct: true,
                select: [
                    "**",
                    "refUserCompany.refPersonType.*",
                    "refUser.refPersonType.*",
                    "refInform.refOriginDestinationCountry.*",
                    "refInform.refUserCompany.*",
                    "refHazDiscuss.refManufactureCountry.*",
                    "refHazDiscuss.refSubStanceTypeMain.*",
                    "refHazDiscuss.refToUse.*",
                    "refHazDiscuss.refMainOperation.*",
                    "refHazDiscuss.refSubOperation.*",
                    "refHazDiscuss.refMainObjective.*",
                    "refHazDiscuss.refSubObjective.*",
                    "refHazDiscuss.refCountry.*",
                    "refHazDiscuss.refDiscussTopic.*",
                    "refHazDiscuss.refResult.refSpecies.*"
                ],
                page: 0,
                size: 1,
                where: [{ name: "id", type: "UUID", operator: "=", value: id }],
                children: [
                    {
                        name: "refUserCompany.addresses",
                        select: ["*"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    },
                    {
                        name: "refUser.addresses",
                        select: ["*"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    },
                    {
                        name: "refInform.products",
                        select: ["**", "refToWhom.*"],
                        page: 0,
                        size: 10000000
                    },
                    {
                        name: "addresses",
                        select: ["**"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    },
                    {
                        name: "attachments",
                        select: ["*"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    },
                    {
                        name: "refHazDiscuss.requests",
                        asName: "refHazDiscuss.lastRequestApprove",
                        select: ["*"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refStatus.key", type: "String", operator: "=", value: "approve" }],
                        sort: [{ name: "createDate", type: "DESC" }],
                        children: [
                            {
                                name: "statuses",
                                asName: "lastStatusApprove",
                                select: ["**"],
                                page: 0,
                                size: 1,
                                where: [{ name: "refStatus.key", type: "String", operator: "=", value: "approve" }],
                                sort: [{ name: "createDate", type: "DESC" }]
                            }
                        ]
                    },
                    {
                        name: "refInform.requests",
                        asName: "refInform.lastRequestApprove",
                        select: ["*"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refStatus.key", type: "String", operator: "=", value: "approve" }],
                        sort: [{ name: "createDate", type: "DESC" }],
                        children: [
                            {
                                name: "statuses",
                                asName: "lastStatusApprove",
                                select: ["**"],
                                page: 0,
                                size: 1,
                                where: [{ name: "refStatus.key", type: "String", operator: "=", value: "approve" }],
                                sort: [{ name: "createDate", type: "DESC" }]
                            }
                        ]
                    }
                ]
            }
        })
        .then(page => page.data[0]);
};

export const createColumns = () => {
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.request.requestCode"), dataIndex: "requestCode", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("views.request.approveCode"),
            dataIndex: "refToWhom.approveCode",
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("model.toWhom.expireDate"),
            dataIndex: "refToWhom.expireDate",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.toWhom.refHazDiscussAppoveCode"),
            dataIndex: "refToWhomTemp.refHazDiscuss.approveCode",
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.toWhom.refObjective"),
            dataIndex: "refToWhomTemp.refObjective.value",
            customRender: ({ record }) => <div>{record.refToWhomTemp?.refObjective?.value}</div>,
            inputProp: () => ({ list: callObjectiveType, optLabel: "value" }),
            search: { name: "refObjective.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refRequestType"),
            dataIndex: "refRequestType.value",
            customRender: ({ record }) => <div>
                <span>{record.refRequestType?.value}</span>
                {record.isSignCa ? <CIcon class="ml-1" file="sign.svg"></CIcon> : null}
            </div>,
            inputProp: () => ({ list: callRequestType, optLabel: "value" }),
            search: { name: "refRequestType.id" },
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refStatus"),
            dataIndex: "refStatus.value",
            customRender: ({ record }) => <div>{record.refStatus?.value}</div>,
            inputProp: () => ({ list: callRequestStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ props, data, refs, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRequestType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.refRequestType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequestType,
                            "onUpdate:value": value => {
                                const oldValue = model.refRequestType;
                                model.refRequestType = value;
                                if (
                                    (["2"].includes(oldValue?.key) || (!["1"].includes(oldValue?.key) && ["1"].includes(value?.key))) &&
                                    model.refToWhom
                                ) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", { text: i18n.global.t("model.request.refRequestType") }),
                                        autoFocusButton: "cancel",
                                        onOk: () => {
                                            if (["1"].includes(value?.key)) {
                                                const { createForm } = require("./request.logic");
                                                cloneToWhom({ model: createForm({ props, data, refs }) });
                                            } else {
                                                cloneToWhom({ model, id: model.refToWhom?.id });
                                            }
                                        },
                                        onCancel: () => {
                                            model.refRequestType = oldValue;
                                        }
                                    });
                                }
                            },
                            disabled: viewOnly,
                            list: callRequestType,
                            optLabel: "value",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refToWhom`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.toWhom.approveCode"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.refToWhom,
                            "onUpdate:value": value => {
                                const oldValue = model.refToWhom;
                                model.refToWhom = value;
                                if (oldValue) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", {
                                            text: i18n.global.t("model.toWhom.approveCode")
                                        }),
                                        autoFocusButton: "cancel",
                                        onOk: () => cloneToWhom({ model, id: value?.id }),
                                        onCancel: () => {
                                            model.refToWhom = oldValue;
                                        }
                                    });
                                } else {
                                    cloneToWhom({ model, id: value?.id });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callToWhom({ searchQuery, userInfo: store.state.resource.auth.info?.user, isOfficerCreate: model.isOfficerCreate }),
                            renderLabel: ({ item }) => (
                                <div>
                                    {item.approveCode} - {item.refUserCompany?.fullNameTh}
                                </div>
                            ),
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forRequestRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.descToOfficer"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forRequestRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forRequestRemark[0].remark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forReceiveRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.descToUserCompany"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forReceiveRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forReceiveRemark[0].remark = value),
                            disabled: viewOnly || !model.refToWhomTemp.refUserCompany
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refToWhomTemp.refObjective`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 17 }, wrapperCol: { xs: 24, md: 7 } }),
                label: () => i18n.global.t("model.toWhom.refObjective"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refToWhomTemp?.refObjective,
                            "onUpdate:value": value => {
                                model.refToWhomTemp.refObjective = value;
                                model.refToWhomTemp.refHazDiscuss = null;
                                model.refToWhomTemp.refInform = null;
                                model.refToWhomTemp.refInformProduct = null;
                                model.refToWhomTemp.registrationNumber = null;
                                model.refToWhomTemp.refCountry = null;
                                lodash.remove(model.refToWhomTemp?.toWhomProducts, d => !d.id);
                                model.refToWhomTemp?.toWhomProducts?.forEach(d => (d.isDelete = true));
                                /*
                                if (value.key === "1") {
                                    data.useToWhomAttachments = data.toWhomAttachments.filter(d => ["1", "2"].includes(d.key));
                                } else if (value.key === "2") {
                                    data.useToWhomAttachments = data.toWhomAttachments.filter(d => ["3", "4", "5"].includes(d.key));
                                } else {
                                    data.useToWhomAttachments = [];
                                }
                                lodash.remove(model.refToWhomTemp?.attachments, d => !d.id);
                                model.refToWhomTemp?.attachments?.forEach(d => (d.isDelete = true));
                                data.useToWhomAttachments.forEach(item =>
                                    model.refToWhomTemp.attachments.push({ documentName: item.value, attribute: lodash.cloneDeep(item.attribute) })
                                );
                                */
                            },
                            disabled: viewOnly,
                            list: callObjectiveType,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            })
        ]
    });
};

export const cloneToWhom = ({ model, id }) => {
    if (id) {
        callToWhomFull({ id }).then(toWhom => {
            const refToWhomTemp = copyForm({ form: { ...toWhom, isTemp: true } });
            if (id) {
                refToWhomTemp.attachments.forEach((d, index) => (d.refRealId = toWhom.attachments[index].id));
                refToWhomTemp.addresses.forEach((d, index) => (d.refRealId = toWhom.addresses[index].id));

                if (toWhom.refObjective.key === "2" && toWhom.refHazDiscuss?.refResult?.isFact) {
                    refToWhomTemp.refInform.products = toWhom.refInform?.products;
                }
            }
            router.push({
                name: router.currentRoute.value.name,
                params: { props: JSON.stringify({ form: { ...model, refDepartment: toWhom.refDepartment, refToWhomTemp } }) },
                query: { _timestamp: new Date().getTime() }
            });
            return callUser({ userCompanyId: refToWhomTemp.refUserCompany.id }).then(users => {
                refToWhomTemp.refUser = users.find(d => d.id === store.state.resource.auth.info?.user?.id) || refToWhomTemp.refUser;
                router.push({
                    name: router.currentRoute.value.name,
                    params: { props: JSON.stringify({ form: { ...model, refDepartment: toWhom.refDepartment, refToWhomTemp } }) },
                    query: { _timestamp: new Date().getTime() }
                });
            });
        });
    } else {
        router.push({
            name: router.currentRoute.value.name,
            params: { props: JSON.stringify({ forceDefault: true, form: model }) },
            query: { _timestamp: new Date().getTime() }
        });
    }
};
